import { FetchContext } from '../fetch-context';
import { ProgramDate } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramDates: (
  fetchContext: FetchContext,
  startDate: string, 
  endDate?: string, 
  dateTypeCode?: string,
  accessToken?: string,
) => Promise<ProgramDate[]> = (fetchContext, startDate, endDate, dateTypeCode, accessToken) => {
  const params = new URLSearchParams();
  params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (dateTypeCode) params.append('dateTypeCode', dateTypeCode);

  const url = `${fetchContext.baseUrl}/api/program-dates${params.size > 0 ? `?${params}` : ''}`;

  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<ProgramDate[]>(fetchContext.errorStore, response, 'get program dates'));
};
